/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, fromJS } from 'immutable';
import { putError } from '../store/error.store';
import { RestAPI } from '../util/net';
import { ReportName } from '@/component/auth/RoleConfigFilter';

const DEFAULT_STORE_NODE_VALUE = Map();

const parseObject = (data) => (data.name == ReportName.CUSTOM_REPORTS_REGIONAL
  ? fromJS(data.users.map(u => ({ id: u.id, customReportOrigins: u.customReportOrigins })))
  : fromJS(data.users.map(u => u.id)));

const updateUsersReportsConfigStore = (state, data) =>
  state.setIn(['config', data.name], parseObject(data));

const storeAllData = (state, dataList) =>
  dataList.reduce((newState, data) => newState.setIn(['config', data.name],
    parseObject(data)), state);

export const reportsConfigReducer = (state = DEFAULT_STORE_NODE_VALUE, action) => {
  switch (action.type) {
    case 'REPORTS_CONFIG_UPDATED_SUCCESSFULLY':
      return updateUsersReportsConfigStore(state, action.data);
    case 'REPORTS_CONFIG_LOADED':
      return storeAllData(state, action.data);
    default:
      return state;
  }
};

export const updateCustomReportsRegionalReportsOrigin =
  (dispatch, reportDataName, userId, origins) => {
    dispatch({ type: 'REPORTS_CONFIG_UPDATE_STARTED' });
    return RestAPI.patch(`/report/config/api/origin/${reportDataName}/${userId}`, origins)
      .then((data) => {
        dispatch({ type: 'REPORTS_CONFIG_UPDATED_SUCCESSFULLY', reportDataName, data });
        return true;
      },
      (data) => {
        dispatch({ type: 'REPORTS_CONFIG_UPDATE_FAILED' });
        putError(dispatch, data);
        return true;
      }
      );
  };

export const updateUsersReportsConfig = (dispatch, reportDataName, users) => {
  dispatch({ type: 'REPORTS_CONFIG_UPDATE_STARTED' });
  return RestAPI.patch(`/report/config/api/${reportDataName}`, users)
    .then((data) => {
      dispatch({ type: 'REPORTS_CONFIG_UPDATED_SUCCESSFULLY', reportDataName, data });
      return true;
    },
    (data) => {
      dispatch({ type: 'REPORTS_CONFIG_UPDATE_FAILED' });
      putError(dispatch, data);
      return true;
    }
    );
};

export const loadReportConfig = (dispatch) => {
  dispatch({ type: 'REPORTS_CONFIG_LOADING_STARTED' });
  return RestAPI.get('/report/config/api')
    .then((data) => {
      dispatch({ type: 'REPORTS_CONFIG_LOADED', data });
      return true;
    },
    (data) => {
      dispatch({ type: 'REPORTS_CONFIG_LOADING_FAILED' });
      putError(dispatch, data);
      return true;
    }
    );
};
